// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',
    sans-serif;
}

.login-card {
  background: white;
  border-radius: 20px;
  padding: 50px 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 420px;
}

.login-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 40px;
  letter-spacing: -0.5px;
}

.form-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
}

.login-input {
  border: none;
  background-color: #e0e0e0;
  border-radius: 15px;
  padding: 12px 20px;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
  height: 45px;
}

.login-input::placeholder {
  color: #999;
}

.login-input:focus {
  outline: none;
  background-color: #d0d0d0;
  box-shadow: 0 0 10px rgba(91, 155, 213, 0.3);
}

.login-input:disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
}

.btn-login {
  background-color: #1a2d4a;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  height: 50px;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.btn-login:hover:not(:disabled) {
  background-color: #0f1a2e;
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);
}

.btn-login:active:not(:disabled) {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.register-link {
  text-decoration: none;
  color: #5b9bd5;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.register-link:hover {
  color: #3d7ba1;
  text-decoration: underline;
}

.alert {
  border-radius: 10px;
  border: none;
  margin-bottom: 20px;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
}

@media (max-width: 600px) {
  .login-card {
    padding: 30px 20px;
  }

  .login-title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .form-label {
    font-size: 14px;
  }

  .login-input {
    font-size: 13px;
  }

  .btn-login {
    font-size: 14px;
    height: 45px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb;;cAEY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',\n    sans-serif;\n}\n\n.login-card {\n  background: white;\n  border-radius: 20px;\n  padding: 50px 40px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 420px;\n}\n\n.login-title {\n  text-align: center;\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 40px;\n  letter-spacing: -0.5px;\n}\n\n.form-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.login-input {\n  border: none;\n  background-color: #e0e0e0;\n  border-radius: 15px;\n  padding: 12px 20px;\n  font-size: 14px;\n  color: #666;\n  transition: all 0.3s ease;\n  height: 45px;\n}\n\n.login-input::placeholder {\n  color: #999;\n}\n\n.login-input:focus {\n  outline: none;\n  background-color: #d0d0d0;\n  box-shadow: 0 0 10px rgba(91, 155, 213, 0.3);\n}\n\n.login-input:disabled {\n  background-color: #f0f0f0;\n  cursor: not-allowed;\n}\n\n.btn-login {\n  background-color: #1a2d4a;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  padding: 12px 30px;\n  font-size: 16px;\n  font-weight: 600;\n  height: 50px;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n}\n\n.btn-login:hover:not(:disabled) {\n  background-color: #0f1a2e;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);\n}\n\n.btn-login:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-login:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.register-link {\n  text-decoration: none;\n  color: #5b9bd5;\n  font-size: 16px;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.register-link:hover {\n  color: #3d7ba1;\n  text-decoration: underline;\n}\n\n.alert {\n  border-radius: 10px;\n  border: none;\n  margin-bottom: 20px;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n@media (max-width: 600px) {\n  .login-card {\n    padding: 30px 20px;\n  }\n\n  .login-title {\n    font-size: 24px;\n    margin-bottom: 30px;\n  }\n\n  .form-label {\n    font-size: 14px;\n  }\n\n  .login-input {\n    font-size: 13px;\n  }\n\n  .btn-login {\n    font-size: 14px;\n    height: 45px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
